function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3D88D2",
  fillRule: "evenodd",
  d: "M1.109 2.523l2.183 2.183a3.008 3.008 0 000 2.588L1.11 9.477a6.005 6.005 0 010-6.954zM2.523 1.11a6.005 6.005 0 016.954 0L7.294 3.292a3.008 3.008 0 00-2.588 0L2.523 1.11zm8.368 8.368L8.708 7.294c.39-.816.39-1.772 0-2.588l2.183-2.183a6.005 6.005 0 010 6.954zM9.477 10.89a6.005 6.005 0 01-6.954 0l2.183-2.183c.816.39 1.772.39 2.588 0l2.183 2.183z"
});

function SvgSupportIcon(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 12
  }, props), _ref);
}

export default SvgSupportIcon;